var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_1102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.143 0C10.6733 0 10.2926 0.383705 10.2926 0.857145H10.2859V7.7143C10.2859 8.1877 9.90215 8.57145 9.4287 8.57145C8.95525 8.57145 8.57155 8.1877 8.57155 7.7143V0.857145H8.56485C8.56485 0.383705 8.1841 0 7.71445 0C7.24475 0 6.864 0.383705 6.864 0.857145H6.8573V7.7143C6.8573 8.1877 6.4736 8.57145 6.00015 8.57145C5.5267 8.57145 5.143 8.1877 5.143 7.7143V0.857145C5.143 0.383705 4.76224 0 4.29255 0C3.82287 0 3.44211 0.383705 3.44211 0.857145H3.42871V9.42855C3.42871 10.483 4.48662 11.389 6.00015 11.7858V22.2857C6.00015 23.2324 6.7677 24 7.71445 24C8.66115 24 9.4287 23.2324 9.4287 22.2857V11.7858C10.9423 11.389 12.0002 10.483 12.0002 9.42855V0.857145H11.9935C11.9935 0.383705 11.6127 0 11.143 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1432 0C17.0662 0 14.5718 5.37255 14.5718 12C14.5718 12.5821 14.5911 13.1544 14.6283 13.7143H17.1432V22.2857C17.1432 23.2324 17.9108 24 18.8575 24C19.8043 24 20.5718 23.2324 20.5718 22.2857V0.0349553C20.4304 0.0117857 20.2875 0 20.1432 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_1102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.8dbed4e702f97ec16c73486e58e18af2.svg";
export { ForwardRef as ReactComponent };